/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FileInfo {
  docKey: string;
  documentType: string;
  signedUrl: string;
}

type MatchModalType =
  | 'matchActionModal'
  | 'matchSuccessModal'
  | 'matchFileModal'
  | 'matchFileViewModal'
  | '';

interface IMatchesSlice {
  isShowMatchesModal: boolean;
  activeMatchesModal: MatchModalType;
  matchAction: 'accept' | 'reject' | '';
  matchUser: string;
  matchFileInfo: FileInfo | null;
  selectedMemberId: string | null;
  isGroupAction: boolean;
  currentGroupData: any | null;
}

const initialState: IMatchesSlice = {
  isShowMatchesModal: false,
  activeMatchesModal: '',
  matchAction: '',
  matchUser: '',
  matchFileInfo: null,
  selectedMemberId: null,
  isGroupAction: false,
  currentGroupData: null
};

export const matchesSlice = createSlice({
  name: 'matches',
  initialState,
  reducers: {
    setIsShowMatchesModal: (state, action: PayloadAction<boolean>) => {
      state.isShowMatchesModal = action.payload;
    },
    setActiveMatchesModal: (state, action: PayloadAction<MatchModalType>) => {
      state.activeMatchesModal = action.payload;
    },
    setMatchAction: (state, action: PayloadAction<'accept' | 'reject' | ''>) => {
      state.matchAction = action.payload;
    },
    setMatchUser: (state, action: PayloadAction<string>) => {
      state.matchUser = action.payload;
    },
    setMatchFileInfo: (state, action: PayloadAction<FileInfo | null>) => {
      state.matchFileInfo = action.payload;
    },
    setSelectedMemberId: (state, action: PayloadAction<string | null>) => {
      state.selectedMemberId = action.payload;
    },
    setIsGroupAction: (state, action: PayloadAction<boolean>) => {
      state.isGroupAction = action.payload;
    },
    setCurrentGroupData: (state, action: PayloadAction<any | null>) => {
      state.currentGroupData = action.payload;
    },
    resetMatchModalState: (state) => {
      state.isShowMatchesModal = false;
      state.activeMatchesModal = '';
      state.matchAction = '';
      state.matchUser = '';
      state.matchFileInfo = null;
      state.selectedMemberId = null;
      state.isGroupAction = false;
    }
  }
});

const { actions, reducer } = matchesSlice;

export const {
  setIsShowMatchesModal,
  setActiveMatchesModal,
  setMatchAction,
  setMatchUser,
  setMatchFileInfo,
  setSelectedMemberId,
  setIsGroupAction,
  setCurrentGroupData,
  resetMatchModalState
} = actions;

export default reducer;
